export type ShortcutButtonData = {
	variant:
		| 'default'
		| 'blueIcon'
		| 'white'
		| 'black'
		| 'seguros'
		| 'defaultStroke'
		| 'whiteStroke'
		| 'blackStroke'
		| 'segurosStroke';
	icon?: string;
	label: string;
	isLink?: boolean;
	url?: string;
	externalLink?: boolean;
	isModal?: boolean;
	iconModal?: string;
	textModal?: string;
	flagAction?: 'buttons' | 'apps';
	subTextModal?: string;
	iconOne?: string;
	labelOne?: string;
	urlOne?: string;
	externalLinkOne?: boolean;
	iconTwo?: string;
	labelTwo?: string;
	urlTwo?: string;
	externalLinkTwo?: boolean;
};

export type ShortcutHomeProps = {
	title: string;
	titleMobile: string;
	darkMode?: boolean;
	shortcutButtons: ShortcutButtonData[];
};
export const apps = {
	'apple-store': {
		url: 'https://apps.apple.com/app/apple-store/id1511026277?pt=304855&ct=hub-vendas-rodape&mt=8',
		alt: 'Apple Store',
	},
	'play-store': {
		url: 'https://play.google.com/store/apps/details?id=br.com.portoseguro.experienciacliente.mundoporto&referrer=utm_source%3Dhub-vendas%26utm_medium%3Dcta-download%26utm_campaign%3Dhub-vendas-rodape&pli=1',
		alt: 'Play Store',
	},
};
